import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';
import { IconButton, FAB, Button } from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import {
  ReviewSearchNavigationContext,
  useSearch,
} from '../providers/SearchProvider';
import { theme } from '../constants/theme';

interface SearchTriggerProps {
  variant?: 'icon' | 'fab' | 'button' | 'header';
  reviewId: number; // Required - only works within a review context
  size?: number;
  style?: StyleProp<ViewStyle>;
  iconColor?: string;
  navigationContext?: ReviewSearchNavigationContext;
  testID?: string;
}

export const SearchTrigger: React.FC<SearchTriggerProps> = ({
  variant = 'icon',
  reviewId,
  size = 24,
  style,
  iconColor = theme.colors.primary,
  navigationContext = 'Reviews',
  testID,
}) => {
  const { showSearchModal } = useSearch();

  const handlePress = () => {
    showSearchModal(reviewId, navigationContext);
  };

  switch (variant) {
    case 'fab':
      return (
        <FAB
          testID={testID}
          icon="magnify"
          style={[styles.fab, style]}
          onPress={handlePress}
          size="medium"
        />
      );

    case 'button':
      return (
        <Button
          testID={testID}
          mode="outlined"
          icon="magnify"
          onPress={handlePress}
          style={[styles.button, style]}
          compact
        >
          Search
        </Button>
      );

    case 'header':
      return (
        <IconButton
          testID={testID}
          icon="magnify"
          size={size}
          iconColor={iconColor}
          onPress={handlePress}
          style={[styles.headerIcon, style]}
        />
      );

    case 'icon':
    default:
      return (
        <TouchableOpacity
          testID={testID}
          onPress={handlePress}
          style={[styles.iconContainer, style]}
          activeOpacity={0.7}
        >
          <MaterialCommunityIcons
            name="magnify"
            size={size}
            color={iconColor}
          />
        </TouchableOpacity>
      );
  }
};

const styles = StyleSheet.create({
  fab: {
    position: 'absolute',
    margin: 16,
    right: 0,
    bottom: 0,
    backgroundColor: theme.colors.primary,
  },
  button: {
    marginHorizontal: 4,
  },
  headerIcon: {
    margin: 0,
  },
  iconContainer: {
    padding: 8,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
